import * as React from 'react'

import { ELEMENTARY_AND_MIDDLE_SCHOOL_ELA, ENGLISH_LEARNERS, HIGH_SCHOOL_ELA, SOCIAL_STUDIES, } from './constants'
import tourToSlides from './tour_to_slides'
import { EARTH_ICON, FOUNTAIN_PEN_ICON, PENCIL_ICON, RESEARCH_BOOKS_ICON, SHIP_ICON } from './asset_constants'

const tourSelectionCardCopy = {
  [ELEMENTARY_AND_MIDDLE_SCHOOL_ELA]: {
    img: <img alt="" src={PENCIL_ICON} />,
    title: 'Elementary & Middle School ELA',
    description: 'Learn how to use Quill to diagnose your students\' writing needs and assign personalized grammar and sentence-construction activities. You\'ll see how real-time feedback strengthens student writing—and how easy it is to track growth with robust reports.'
  },
  [ENGLISH_LEARNERS]: {
    img: <img alt="" src={EARTH_ICON} />,
    title: 'English Learners',
    description: 'Learn how to use Quill to support multilingual learners with placement diagnostics and translations for 16 languages. See how real-time feedback and scaffolded activities build writing skills for ELL students at every proficiency level.'
  },
  [HIGH_SCHOOL_ELA]: {
    img: <img alt="" src={RESEARCH_BOOKS_ICON} />,
    title: 'High School ELA',
    description: 'Learn how to use Quill to pinpoint high schoolers\' language skill gaps. See how Quill\'s new Reading for Evidence tool helps students build stronger evidence-based writing with paired texts, targeted prompts, and real-time feedback.'
  },
  [SOCIAL_STUDIES]: {
    img: <img alt="" src={SHIP_ICON} />,
    title: 'High School Social Studies',
    description: 'Learn how to blend literacy with social studies using Quill Reading for Evidence. See students annotate nonfiction texts and craft evidence-based sentences on key historical moments. Watch real-time feedback track mastery of claims, context, and causation to build critical thinking.'
  },
}

const TourSelectionCard = ({ id, selectTour, }) => {
  function handleClickSelect() { selectTour(id) }

  const disabled = !tourToSlides[id]

  return (
    <section className="tour-selection-card">
      <div className="text">
        <h2>{tourSelectionCardCopy[id].img}{tourSelectionCardCopy[id].title}</h2>
        <p>{tourSelectionCardCopy[id].description}</p>
      </div>
      <button
        aria-label={`Select tour for ${tourSelectionCardCopy[id].title}`}
        className="quill-button large contained green focus-on-light"
        disabled={disabled}
        onClick={handleClickSelect}
        type="button"
      >{disabled ? 'Coming soon' : 'Select'}</button>
    </section>
  )
}

export default TourSelectionCard
